<template>
  <div>
    <v-dialog v-model="leadingReportDialog" persistent max-width="800px">
      <template v-slot:activator="{ attrs }">
        <p
          id="leadingReportForm"
          v-bind="attrs"
          @click="openLeadingReportDialog"
        ></p>
      </template>
      <v-card v-if="objForm !== null">
        <v-card-title>
          <span class="text-h5">Add/Edit Report</span>
        </v-card-title>
        <v-form
          ref="leadingReportRef"
          @submit.prevent="saveLeadingReport"
          :disabled="loading"
        >
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Perusahaan
                  </p>
                  <v-autocomplete
                    v-model="objForm.company"
                    :items="dropdown.company"
                    :rules="rules.companyRules"
                    item-text="name"
                    item-value="id"
                    return-object
                    dense
                    outlined
                    clearable
                    style="height: 45px"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="8" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Jenis Kegiatan
                  </p>
                  <v-autocomplete
                    v-model="objForm.leading"
                    :items="dropdownLeading"
                    :rules="rules.leadingRules"
                    item-text="name"
                    item-value="id"
                    return-object
                    dense
                    outlined
                    clearable
                    style="height: 45px"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="4" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Tgl. Kegiatan
                  </p>
                  <v-text-field
                    v-model="objForm.leading_date"
                    :rules="rules.dateRules"
                    type="date"
                    dense
                    outlined
                    style="height: 45px"
                  />
                </v-col>
                <v-col cols="4" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Jml Peserta
                  </p>
                  <v-text-field
                    v-model="objForm.total_participant"
                    :rules="rules.participantRules"
                    type="number"
                    dense
                    outlined
                    style="height: 45px"
                  />
                </v-col>
                <!-- <v-col cols="6" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Lokasi Kegiatan
                  </p>
                  <v-text-field
                    v-model="objForm.location"
                    dense
                    outlined
                    style="height: 45px"
                  />
                </v-col> -->
                <!-- <v-col cols="12" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Dilaksanakan Oleh
                  </p>
                  <v-text-field
                    v-model="objForm.cause"
                    dense
                    outlined
                    style="height: 45px"
                  />
                </v-col> -->

                <v-col cols="12" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Deskripsi Kegiatan
                  </p>
                  <v-textarea
                    v-model="objForm.description"
                    :rules="rules.descriptionRules"
                    :auto-grow="true"
                    rows="3"
                    outlined
                    clear-icon="mdi-close-circle"
                  ></v-textarea>
                </v-col>
                <!-- <v-col
                  cols="4"
                  class="d-flex flex-column position-relative"
                  style="top: -35px"
                >
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Status
                  </p>
                  <v-autocomplete
                    v-model="objForm.status"
                    :items="dropdown.leadingStatus"
                    :rules="rules.statusRules"
                    dense
                    outlined
                    clearable
                    style="height: 45px"
                  ></v-autocomplete>
                </v-col> -->
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red darken-1"
              text
              @click="closeLeadingReportDialog"
              :loading="loading"
            >
              Close
            </v-btn>
            <v-btn color="blue darken-1" text type="submit" :loading="loading">
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import buildType from '../../../../../services/buildType'
export default {
  name: 'FormLeadingReport',
  props: ['dropdown', 'updateForm'],
  components: {},
  data() {
    return {
      dssApi: buildType.apiURL('dss'),
      loading: false,
      leadingReportDialog: false,
      objForm: null,
      rules: {
        companyRules: [],
        leadingRules: [],
        dateRules: [],
        participantRules: [],
        descriptionRules: [],
        statusRules: []
      },
      dropdownLeading: [],
      dropdownLeadingStatus: []
    }
  },
  computed: {
    ...mapGetters(['getUserProfile'])
  },
  watch: {
    // searchVendor(val) {
    //   if (val !== '') {
    //     val && val !== this.selectedVendor && this.querySelections(val)
    //   } else {
    //     this.selectedVendor = null
    //     this.dropdown.vendor = []
    //   }
    // },
    // 'form.vendor_type'() {
    //   if (this.form != null) {
    //     this.form.vendor = null
    //     this.form.vendor_name = null
    //   }
    // }
  },
  methods: {
    onResize() {
      this.wWidth = window.innerWidth
    },
    showMsgDialog(
      pModalType,
      pStatusMsg,
      pBtnCancel,
      pInputType,
      pInputAtt,
      yesBtn,
      noBtn,
      pText
    ) {
      const title =
        pInputType === 'file'
          ? 'Upload bukti approvement pada kolom dibawah'
          : ''

      let additional = ''
      if (pText !== undefined) {
        additional = '<span style="font-size:12px;">' + pText + '</span>'
      }
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html:
              '<strong style="font-size:18px;">' +
              pStatusMsg +
              '</strong>' +
              '<br/>' +
              additional,
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            input: pInputType !== undefined ? pInputType : null,
            inputLabel: pInputType !== undefined ? title : null,
            inputAttributes: pInputAtt !== undefined ? pInputAtt : null,
            confirmButtonText: yesBtn || 'Yes',
            cancelButtonText: noBtn || 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    // querySelections(v) {
    //   const url = `${this.proc}vendor/dropdown?keyword=${v}&offset=0&limit=10&order_by=name&order_type=asc`
    //   // if (this.form.department !== null) {
    //   //   url = url + `&department_parent_id=${this.form.department.id}`
    //   // }
    //   axios
    //     .get(url)
    //     .then((res) => {
    //       // this.loading = false
    //       if (res.data.status_code === '00') {
    //         const resArr = []
    //         for (let i = 0; i < res.data.data.length; i++) {
    //           resArr.push({
    //             id: res.data.data[i].id,
    //             code: res.data.data[i].code,
    //             name: res.data.data[i].name
    //           })
    //         }
    //         return (this.dropdown.vendor = resArr)
    //       }
    //       return (this.dropdown.vendor = [])
    //     })
    //     .catch((err) => {
    //       this.dropdown.vendor = []
    //       return console.log(err)
    //     })
    // },
    openLeadingReportDialog() {
      console.log('user>>', this.getUserProfile)
      this.initDropdown()
      // const arrDetails = []
      if (this.updateForm != undefined && this.updateForm != null) {
        this.objForm = this.updateForm
      } else {
        this.objForm = {
          act: 'add',
          company: {
            id: Number(this.getUserProfile.employee.company.plant_id),
            name: this.getUserProfile.employee.company.name
          },
          leading: null,
          leading_date: null,
          description: null,
          // status: null,
          file: null,
          total_participant: null
        }
      }
      setTimeout(() => {
        // this.startWatcher()
        this.leadingReportDialog = true
      }, 500)
    },
    initDropdown() {
      this.getDropdownLeading()
      this.dropdownLeadingStatus = ['Draft', 'Submitted', 'Cancel']
    },
    getDropdownLeading() {
      const url = `${this.dssApi}master/universal/leadingkpi/dropdown?keyword=`
      axios
        .get(url)
        .then((res) => {
          if (res.data.status_code === '00') {
            this.dropdownLeading = res.data.data
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    clickOutside() {
      this.closeLeadingReportDialog()
    },
    closeLeadingReportDialog() {
      this.leadingReportDialog = false
      setTimeout(() => {
        this.objForm = null
        this.dropdownLeading = []
        this.dropdownLeadingStatus = []
        this.$emit('loadPage')
      }, 200)
    },
    saveLeadingReport() {
      this.rules.companyRules = [(v) => !!v || 'Kolom company wajib di isi']
      this.rules.leadingRules = [(v) => !!v || 'Kolom kegiatan wajib di isi']
      this.rules.dateRules = [
        (v) => !!v || 'Kolom tanggal kegiatan wajib di isi'
      ]
      this.rules.participantRules = [
        (v) => !!v || 'Kolom jumlah partisipan wajib di isi'
      ]
      this.rules.deskripsiRules = [(v) => !!v || 'Kolom deskripsi wajib di isi']
      this.rules.statusRules = [(v) => !!v || 'Kolom status wajib di isi']

      const self = this
      setTimeout(function () {
        if (self.$refs.leadingReportRef.validate()) {
          self.createNewForm()
        }
      })
    },
    createNewForm() {
      const newForm = {
        act: this.objForm.act,
        company_id: this.objForm.company.id,
        company_name: this.objForm.company.name,
        leading_id:
          this.objForm.leading != null ? this.objForm.leading.id : null,
        leading_date: this.objForm.leading_date,
        description: this.objForm.description,
        // status: this.dropdown.leadingStatus.indexOf(this.objForm.status),
        file: this.objForm.file,
        total_participant: this.objForm.total_participant
      }
      if (this.objForm.act == 'update') {
        Object.assign(newForm, {
          id: this.objForm.id,
          status: this.objForm.status.id
        })
      }
      if (this.objForm.act == 'add') {
        Object.assign(newForm, {
          status: 1
        })
      }

      console.log('createNewForm', newForm)
      this.submitLeadingReport(newForm)
    },
    async submitLeadingReport(form) {
      this.loading = true
      await axios
        .post(`${this.dssApi}leadingreport/save`, form)
        .then((res) => {
          this.loading = false
          if (res.data.status_code == '00') {
            const created_id = res.data.created_id
            console.log(created_id)
            // this.showMsgDialog('success', res.data.status_msg, false)
            this.closeLeadingReportDialog()
            // setTimeout(() => {
            //   // this.$store.commit('setFpbId', created_id)
            //   this.$router.push(
            //     `/e-catalogue/payreq/detail/${created_id}?idx=0`
            //   )
            // }, 100)
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    convertDate(raw) {
      if (raw !== null) {
        const date = new Date(raw)
        const local = date.toLocaleString('id')
        return local
      } else {
        return '-'
      }
    }
  }
}
</script>
